import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import Typography from '../../typography/Typography';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, IconSizeTokens, IconTokens, TextAlignTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Icon from '../../icon/Icon';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import { isMobileView } from '../../stack/utils';
import { showRegisterCustomer, showShareLink } from '../utils';
const EmptyScreen = ({ shareLinkAction, trackPendingCustomerJourney, triggerAction, }) => {
    const [showRC, setShowRCustomer] = useState(showRegisterCustomer());
    const [showLink, setShowLink] = useState(showShareLink());
    return (React.createElement(View, { style: { marginTop: 40, alignItems: 'center' } },
        React.createElement(Icon, { name: IconTokens.PENDING_LIST, size: IconSizeTokens.SIZE_164 }),
        React.createElement(View, { style: { marginTop: 16 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: 'No pending application found', color: ColorTokens.Grey_Night })),
        React.createElement(View, { style: { marginTop: 20, width: isMobileView() ? '100%' : '45%', flex: 1 } },
            React.createElement(View, { style: { paddingHorizontal: 12, paddingVertical: 8, backgroundColor: '#F9FAFB', borderRadius: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Invite your customers and help them fulfill short term cash need without selling securities', color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center })),
            !isMobileView() && React.createElement(View, { style: { marginTop: 16, flexDirection: 'row', width: '100%' } },
                showLink &&
                    React.createElement(View, { style: { flex: 1 } },
                        React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.SECONDARY, label: 'Share unique link', onPress: async () => {
                                await triggerAction({
                                    ...shareLinkAction,
                                    payload: {
                                        ...shareLinkAction.payload,
                                    }
                                });
                            }, isDisabled: false })),
                showRC &&
                    React.createElement(View, { style: { marginLeft: 12, flex: 1 } },
                        React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Register customer', onPress: async () => {
                                await triggerAction({
                                    ...trackPendingCustomerJourney,
                                    payload: {
                                        customerType: 'PENDING_REGISTRATION',
                                        ...trackPendingCustomerJourney.payload,
                                    }
                                });
                            }, isDisabled: false }))))));
};
const styles = StyleSheet.create({});
export default EmptyScreen;
